import { Stack } from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import ImageAssets from "../../../assets";
import { MuiStyledButton } from "../../../components/common/button/MuiButton";
import { loginRedux } from "../../../redux/login-redux/LoginRedux";
import strings from "../../../strings/Strings";
import { getLocalStorageItem } from "../../../utils/LocalStorage";
import styles from "../HelpAndSupport.module.css";
import ArrowBackIosNewRoundedIcon from "@mui/icons-material/ArrowBackIosNewRounded";

const MobileBlockUsersList = () => {

    const navigate = useNavigate();
    const [blockedUsers, setBlockedUsers] = useState([]);

    const actionDispatch = (dispatch: any) => ({
        blockUserRequest: (data: any) =>
            dispatch(loginRedux.actions.blockUserRequest(data)),
    });

    const {
        blockUserRequest
    } = actionDispatch(useDispatch());

    const fetchBlockedUsersList = async () => {
        const response = await fetch(`${process.env.REACT_APP_SEKERON_USER_MANEGEMENT_URL}/user/block-list`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `${getLocalStorageItem("token")}`,
            },
        });
        const data = await response?.json();
        console.log(data, "linedata")
        setBlockedUsers(data?.data);
    }

    useEffect(() => {
        fetchBlockedUsersList();
    }, []);

    const handleClickOnBlockUser = (id: any) => {
        blockUserRequest({ userId: id, status: 0 });
        let array = blockedUsers;
        let data = array.filter((item) => item?.userId !== id)
        setBlockedUsers([...data]);
    }

    return (
        <>
            <div className={styles["header-container"]}>
                <ArrowBackIosNewRoundedIcon onClick={() => navigate(-1)} />
                <p>Blocked Users</p>
            </div>
            <Stack gap={3} flexDirection={"column"} className={styles["block-users"]} >
                {blockedUsers && blockedUsers?.length > 0 ?
                    blockedUsers?.map((item, dataIndex) => {
                        return (
                            <div key={dataIndex} className={styles["user-details"]}>
                                <img
                                    src={
                                        item?.profilePicture
                                            ? item?.profilePicture
                                            : ImageAssets.ic_dummy_profile
                                    }
                                    className={styles["profile-picture"]}
                                    alt="profile-pic"
                                    onClick={() => {
                                        navigate(`/profile/others-profile/${item?.userId}`);
                                    }}
                                />
                                <div>
                                    <div
                                        onClick={() => {
                                            navigate(`/profile/others-profile/${item?.userId}`);
                                        }}
                                    >
                                        <span>{item?.fullName}</span>
                                        <span>{item?.username}</span>
                                    </div>
                                    <MuiStyledButton
                                        className={"follow-button"}
                                        onClick={() => handleClickOnBlockUser(item?.userId)}
                                    >
                                        {"Unblock"}
                                    </MuiStyledButton>
                                </div>
                            </div>
                        );

                    })
                    : 
                    <div style={{width: '100%', height:'100%', display:'flex', justifyContent:'center', flexDirection:'column', alignItems:'center'}}>
                    <img src={ImageAssets.ic_blocked_users} className={styles["no_block_list"]} />
                    </div>
                }
            </Stack>
        </>
    );
}
export default MobileBlockUsersList;